import { useEffect } from 'react';
import { MatchesCatalogComparator } from '../../../../types';
import { useMatchesCatalogContext } from '../../../../contexts/matchesCatalog';

export const useTrackMatchesCatalogSelection = (value: string | null) => {
  const isCurrentValueMatchesCatalog = value === MatchesCatalogComparator.MATCHES_CATALOG_DATA;
  const { isMatchesCatalogSelected, setIsMatchesCatalogSelected } = useMatchesCatalogContext();
  useEffect(() => {
    if (isCurrentValueMatchesCatalog) setIsMatchesCatalogSelected(true);
    // cleanup function
    return () => {
      if (isCurrentValueMatchesCatalog && isMatchesCatalogSelected) {
        setIsMatchesCatalogSelected(false);
      }
    };
  }, [isCurrentValueMatchesCatalog, isMatchesCatalogSelected, setIsMatchesCatalogSelected]);
};
